


























































































































































import { mapState, mapGetters } from 'vuex'
import axios from 'axios'
import Vue from 'vue'
const _ = require('lodash')

export default Vue.extend({
  model: {
    prop: 'visible',
    event: 'change'
  },

  props: {
    visible: Boolean,
    queryId: Number,
    newScheduleQueryData: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      newScheduleData: this.newScheduleQueryData
    }
  },

  computed: {
    ...mapState('scheduledQuery', {
      minutes: 'minutes',
      hours: 'hours',
      daysOfWeek: 'daysOfWeek'
    }),

    ...mapState('user', {
      users: 'allUsers'
    }),

    ...mapGetters('user', {
      user: 'getUser'
    })
  },

  watch: {
    newScheduleQueryData () {
      this.newScheduleData = this.newScheduleQueryData
    }
  },

  methods: {
    onModalVisibleChange (visible: Boolean) {
      this.$emit('change', visible)
    },

    onCloseModal (): void {
      this.$emit('close')
    },

    /**
     * Takes form name as input, validates based on model's rule. Parse cron schedule from recurrence and time then post to server.
     * Reset model on success and error. Will convert local time input to UTC time for server.
     * @param {String} formName
     */
    setScheduleQuery (formName: string) {
      // @ts-ignore
      this.$refs[formName].validate((valid: boolean) => {
        if (!valid) {
          this.$Message.error('Missing Info!')
          return
        }
        const time = this.newScheduleData.hourAndMinute.split(':')
        const minute = Number.parseInt(time[1]) || 0
        const hour = Number.parseInt(time[0]) || 0
        let dayOfWeek = this.newScheduleData.day
        const hourOffset = new Date().getTimezoneOffset() / 60
        const forwardOneDay = (hour + hourOffset > 24)
        const backOneDay = (hour + hourOffset < 0)
        const utcHour = ((((hour + hourOffset) % 24) + 24) % 24)
        if (dayOfWeek.toString() !== '*') {
          if (forwardOneDay) {
            dayOfWeek++
          }
          if (backOneDay) {
            dayOfWeek--
          }

          dayOfWeek = (((dayOfWeek % 7) + 7) % 7)
        }
        const schedule = `${minute} ${this.newScheduleData.recurrence === 'Hourly' ? '*' : utcHour} * * ${this.newScheduleData.recurrence === 'Weekly' ? dayOfWeek : '*'}`
        let evalString = ''
        if (this.newScheduleData.hasResults) {
          evalString = 'results.length > 0'
        }
        axios({
          method: 'post',
          url: process.env.VUE_APP_API_URI + '/scheduled-queries',
          data: {
            user: this.user.id,
            schedule: schedule,
            queryId: this.queryId,
            emailUserIds: this.newScheduleData.emailSubscribers,
            slackUserIds: this.newScheduleData.slackSubscribers,
            conditional: evalString
          }
        }).then(() => {
          this.$store.dispatch('scheduledQuery/onLoadScheduledQueries', this.user.id)
          this.$store.dispatch('scheduledQuery/onLoadScheduledQueriesSubscriptions', this.user.id)
          this.onCloseModal()
        }).catch(error => {
          this.$Message.error(`Error saving scheduled query: ${_.get(error, 'response.data.error')}`)
          this.onCloseModal()
        })
      })
    }
  }
})
